import { __assign } from "tslib";
export function resolveBucketEndpointConfig(input) {
  var _a = input.bucketEndpoint,
      bucketEndpoint = _a === void 0 ? false : _a,
      _b = input.forcePathStyle,
      forcePathStyle = _b === void 0 ? false : _b,
      _c = input.useAccelerateEndpoint,
      useAccelerateEndpoint = _c === void 0 ? false : _c,
      _d = input.useArnRegion,
      useArnRegion = _d === void 0 ? false : _d,
      _e = input.disableMultiregionAccessPoints,
      disableMultiregionAccessPoints = _e === void 0 ? false : _e;
  return __assign(__assign({}, input), {
    bucketEndpoint: bucketEndpoint,
    forcePathStyle: forcePathStyle,
    useAccelerateEndpoint: useAccelerateEndpoint,
    useArnRegion: typeof useArnRegion === "function" ? useArnRegion : function () {
      return Promise.resolve(useArnRegion);
    },
    disableMultiregionAccessPoints: typeof disableMultiregionAccessPoints === "function" ? disableMultiregionAccessPoints : function () {
      return Promise.resolve(disableMultiregionAccessPoints);
    }
  });
}